import React from "react";
import styled from "styled-components";
import { QuestionStats } from '../../../amorg-common';
import { Card } from "../../../designSystem/Card";

import { SelectionStats } from '../../../amorg-common';
import { SurveyQuestion, Survey, surveyHelper } from '../../../amorg-common';
import { AnswerRatioVerticalGraph } from "./AnswerRatioVerticalGraph";
import { RadialPctChart } from "../../../designSystem/graphs/RadialPctChart";
import { ListRow } from "../../../designSystem/compositeComponents/ListRow";
import { H2 } from "../../../designSystem/typography/Heading";
import { Label } from "../../../designSystem/Label";


type RankedQuestionReport = {
    question: SurveyQuestion,
    report: QuestionStats,
    average: number,
    questionIndex: number
};
type ReportSummaryProps = {
    survey: Survey,
    questionReports: QuestionStats[],
    excludeQuestionSummary?:boolean
}
export function ReportSummary(props: ReportSummaryProps): JSX.Element {
    const aggregatedSelections = SelectionStats.aggregateList(
        props.questionReports.map(r => r.selections.data));

    const answers = props.questionReports.length > 0
        ? props.questionReports[0].selections.totalSelections
        : 0;

    const allThemeQuestions = surveyHelper.getAllSurveyQuestions(props.survey);
    const allQuestions = allThemeQuestions.map(tq => tq.question);

    return (
        <ListRow styleVariant="neutral" sizeVariant="medium">
            <div>
                <H2>
                    {allQuestions.length} spørgsmål med {answers} besvarelser
                    {answers === 0 ? '' : `, og et gennemsnit på ${aggregatedSelections.selectionAverage.toFixed(1) + '/5'}`}
                </H2>
            </div>
            <div style={{display:'flex', marginTop:'30px', gap:'20px'}}>
                <RadialPctChart pct={aggregatedSelections.agreePlusPct} />
                <div style={{flexGrow:1}}>
                    <AnswerRatioVerticalGraph summaryStats={aggregatedSelections} />
                </div>
                {/* <SelectionStatsGraphics stats={aggregatedSelections} /> */}
            </div>

            {(props.excludeQuestionSummary===undefined || props.excludeQuestionSummary===false) &&
                <div style={{marginTop:'10px'}}>
                    <RankedQuestionSummary allQuestions={allQuestions} questionReports={props.questionReports} />
                </div>
            }
        </ListRow>
    )
}

type RankedQuestionSummaryProps = { allQuestions: SurveyQuestion[], questionReports: QuestionStats[] }
function RankedQuestionSummary({ allQuestions, questionReports }: RankedQuestionSummaryProps): JSX.Element {
    const shouldDisplay = questionReports.length > 5
        && questionReports[0].selections.totalSelections > 5;

    const rankedQuestions: RankedQuestionReport[] = questionReports
        .map((v, i) => {

            return {
                question: allQuestions[i],
                report: v,
                average: v.selections.selectionAverage,
                questionIndex: i
            }
        })
        .sort((a, b) => b.average - a.average);

    return (
        <>
            {shouldDisplay &&
                <div style={{display:'grid', gridTemplateRows:'20px 1fr', gridAutoRows:'1fr', gridTemplateColumns:'1fr 1fr', columnGap:'10px', rowGap:'5px', alignContent:'stretch'}}>
                    <Label>
                        De mest positivt besvarede spørgsmål
                    </Label>
                    <Label>
                        De mindst positivt besvarede spørgsmål
                    </Label>
                    <QuestionContainer question={rankedQuestions[0]} />
                    <QuestionContainer question={rankedQuestions[rankedQuestions.length-1]} />
                    <QuestionContainer question={rankedQuestions[1]} />
                    <QuestionContainer question={rankedQuestions[rankedQuestions.length-2]} />
                    <QuestionContainer question={rankedQuestions[2]} />
                    <QuestionContainer question={rankedQuestions[rankedQuestions.length-3]} />
                </div>
            }
        </>
    );
}

type QuestionContainerProps = {
    question:RankedQuestionReport
}
function QuestionContainer(props:QuestionContainerProps):JSX.Element
{
    return (
        <Card variant="outlined">
            <QuestionHeader>
                #{props.question.questionIndex + 1} med et gennemsnit på <b>({props.question.average.toFixed(1)}/5)</b>
            </QuestionHeader>
            <QuestionText>
                {"\"" + props.question.question.title + "\""}
            </QuestionText>
        </Card>
    );
}

const QuestionHeader = styled.div`
    font-size: 12px;
    margin-bottom: 10px;
`
const QuestionText = styled.div`
    font-size: 12px;
    font-style:italic;
    /* correct way of breaking words and preserving white space */
    overflow-wrap: break-word;
    white-space: pre-wrap;
`